/* ============================================================== */
/*   พิมพ์ใบรับรองแพทย์ด้วยแบบฟอร์ม pdfmake เดิมของ V3 (browser only) */
/* ============================================================== */
/*
 * ทำตาม HandlePrintNSaveReport ใน HISV3/DPO/sequence/DoctorCertificate.ts
 * ใช้ dynamic import เพราะแบบฟอร์มและ font มีขนาดใหญ่ และ model ต้องไม่ลาก pdfmake เข้ามา
 */
import CONFIG from "config/config";
import { printURL } from "react-lib/utils/printURL";

import { isPrintableCertCode } from "./documentModelV4";

export const printMedCert = async (formCode: string, data: Record<string, any>): Promise<void> => {
  if (!isPrintableCertCode(formCode)) {
    throw new Error("ใบรับรองชนิดนี้ยังพิมพ์จาก HIS V4 ไม่ได้");
  }

  const isThai = (data.reportLanguage ?? "ไทย") === "ไทย";
  const [form, header, pdfMake] = await Promise.all([
    isThai
      ? import("react-lib/apps/HISV3/DPO/pdfForm/FormExamAbsenceCertificate")
      : import("react-lib/apps/HISV3/DPO/pdfForm/FormExamAbsenceCertificateEN"),
    import("react-lib/apps/HISV3/DPO/sequence/AddHeaderSapienForm"),
    import("react-lib/appcon/common/pdfMake"),
  ]);

  const body = await form.default({ items: { ...data, dayDuration: data.dayDuration || " " } });
  const addHeader = isThai ? header.AddHeaderMedCert : header.AddHeaderMedCertEN;
  const doc = await addHeader(
    body,
    isThai ? data.createdDate : data.createDateForm,
    CONFIG.DISABLE_HEADER_MEDCERT,
  );

  /* createPdf().print() ต้องเปิด popup และ browser บล็อกเมื่อไม่ได้เรียกจากการคลิกโดยตรง
     การพิมพ์เกิดหลังบันทึกเสร็จ จึงพิมพ์ผ่าน iframe แบบเดียวกับ Print list */
  const pdf = (await pdfMake.default(true)).createPdf(doc);
  const blob = await new Promise<Blob>((resolve) => {
    pdf.getBlob((value: Blob) => resolve(value));
  });
  printURL(URL.createObjectURL(blob));
};
